<script setup lang="ts">
import { ref } from 'vue';
import { useTenantStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import AddRSMFile from '@/components/UploadModal/AddRSMFile.vue';

const tenantStore = useTenantStore();
const { loading } = storeToRefs(tenantStore);

const toast = useToast();

const viewModal = ref(false);

const changeViewModal = () => (viewModal.value = !viewModal.value);

const modalCancel = () => {
  viewModal.value = false;
};

const onSave = () => {
  viewModal.value = false;
  doToast();
};

const onError = () => {
  doToast(true);
};

const doToast = (isError?: boolean | string) => {
  toast.add({
    severity: isError ? 'error' : 'success',
    summary: isError ? 'Error' : 'Success',
    detail: isError
      ? 'File not accepted. Please check file and try again'
      : 'File Accepted. Check RSM Activity in Insight Activity Log for Status',
    life: 5000,
  });
};
</script>

<template>
  <Card>
    <template #header>
      <div class="flex flex-column">
        <h2 class="m-0">RSM Sync</h2>
      </div>
    </template>
    <template #content>
      <AppButton type="primary" text="Upload File" @click="changeViewModal" />
      <AddRSMFile
        v-if="viewModal"
        title="Upload RSM File"
        :loading="loading"
        @cancel="modalCancel"
        @save="onSave"
        @error="onError"
      />
    </template>
  </Card>
</template>
